import React from 'react';
import {
  KeyControlsImpactValueBlock,
  KeyControlsImpactWrapper,
} from '@components/MainStage/CustomNode/KeyControlsImpact/KeyControlsImpact.styled';
import { KeyControlsImpactColor } from '@constants/canvas/canvasTheme';
import { ImpactType } from '@store/services/projects/types';

type Props = {
  impact: ImpactType;
};

export const KeyControlsImpact = ({ impact }: Props) => {
  return (
    <KeyControlsImpactWrapper>
      <KeyControlsImpactValueBlock
        $borderColor={KeyControlsImpactColor[impact]}
      >
        {impact}
      </KeyControlsImpactValueBlock>
    </KeyControlsImpactWrapper>
  );
};
